import React from 'react';

function SessionExpiredModal({ show, onClose }) {
    if (!show) return null;

    return (
        <>
            <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1" role="dialog">
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-header bg-warning">
                            <h5 className="modal-title">
                                <i className="fas fa-exclamation-triangle"></i> Sesión Expirada
                            </h5>
                        </div>
                        <div className="modal-body text-center">
                            <i className="fas fa-clock fa-3x text-warning mb-3"></i>
                            <p className="mb-0" style={{ fontSize: '16px' }}>
                                Su sesión ha expirado por inactividad.
                            </p>
                            <p style={{ fontSize: '14px', color: '#666' }}>
                                Por favor, inicie sesión nuevamente para continuar.
                            </p>
                        </div>
                        <div className="modal-footer justify-content-center">
                            <button 
                                type="button" 
                                className="btn btn-primary" 
                                onClick={onClose}
                            >
                                <i className="fas fa-sign-in-alt"></i> Ir al Login
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal-backdrop fade show"></div>
        </>
    );
}

export default SessionExpiredModal;
